import api from './api';

const enc = encodeURIComponent;

export const listDevices = (query = '') => api.get('Fleet/Devices' + query);
export const getDevice = (id) => api.get('Fleet/Devices/' + enc(id));
export const updateDevice = (id, body) => api.put('Fleet/Devices/' + enc(id), body);
// `{ leaveadbopen }` becomes `?leaveadbopen=true|false`; the console always passes it.
export const unenrollDevice = (id, query) =>
  api.delete(
    'Fleet/Devices/' +
      enc(id) +
      (query && typeof query.leaveadbopen === 'boolean'
        ? '?leaveadbopen=' + String(query.leaveadbopen)
        : ''),
  );

export const sendCommand = (id, body) => api.post('Fleet/Devices/' + enc(id) + '/Commands', body);
export const sendBulk = (body) => api.post('Fleet/Commands/Bulk', body);
export const listDeviceCommands = (id, query = '') =>
  api.get('Fleet/Devices/' + enc(id) + '/Commands' + query);
export const getCommand = (id) => api.get('Fleet/Commands/' + enc(id));
export const cancelCommand = (id) => api.post('Fleet/Commands/' + enc(id) + '/Cancel');

export const createToken = (body) => api.post('Fleet/EnrollmentTokens', body);
export const listTokens = () => api.get('Fleet/EnrollmentTokens');
export const revokeToken = (id) => api.post('Fleet/EnrollmentTokens/' + enc(id) + '/Revoke');

export const createCode = (body) => api.post('Fleet/EnrollmentCodes', body);
export const listCodes = () => api.get('Fleet/EnrollmentCodes');
export const revokeCode = (id) => api.post('Fleet/EnrollmentCodes/' + enc(id) + '/Revoke');

export const presignRelease = (body) => api.post('Fleet/Releases/Presign', body);
export const createRelease = (body) => api.post('Fleet/Releases', body);
export const listReleases = () => api.get('Fleet/Releases');
export const markCurrent = (id) => api.post('Fleet/Releases/' + enc(id) + '/Current');
export const deleteRelease = (id) => api.delete('Fleet/Releases/' + enc(id));

export const createRollout = (body) => api.post('Fleet/Rollouts', body);
export const previewRollout = (body) => api.post('Fleet/Rollouts/Preview', body);
export const listRollouts = (query = '') => api.get('Fleet/Rollouts' + query);
export const getRollout = (id) => api.get('Fleet/Rollouts/' + enc(id));
export const pauseRollout = (id) => api.post('Fleet/Rollouts/' + enc(id) + '/Pause');
export const resumeRollout = (id) => api.post('Fleet/Rollouts/' + enc(id) + '/Resume');
export const cancelRollout = (id) => api.post('Fleet/Rollouts/' + enc(id) + '/Cancel');
export const rollbackRollout = (id) => api.post('Fleet/Rollouts/' + enc(id) + '/Rollback');

export const listAudit = (query = '') => api.get('Fleet/Audit' + query);
export const getConfig = () => api.get('Fleet/Config');

const fleetApi = {
  listDevices,
  getDevice,
  updateDevice,
  unenrollDevice,
  sendCommand,
  sendBulk,
  listDeviceCommands,
  getCommand,
  cancelCommand,
  createToken,
  listTokens,
  revokeToken,
  createCode,
  listCodes,
  revokeCode,
  presignRelease,
  createRelease,
  listReleases,
  markCurrent,
  deleteRelease,
  createRollout,
  previewRollout,
  listRollouts,
  getRollout,
  pauseRollout,
  resumeRollout,
  cancelRollout,
  rollbackRollout,
  listAudit,
  getConfig,
};

export default fleetApi;
